module.exports = __webpack_public_path__ + "static/two_car_accident-7211cd66eb97b71e845d495ed44eb1b3.jpg";